var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{staticClass:"el-menu leftMenu",attrs:{"default-active":_vm.tacit,"active-text-color":"","text-color":"#6a6a6a","default-openeds":_vm.openeds},on:{"select":_vm.handleSelect}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f3ddaf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AI/components/recordMenu.vue
// module id = null
// module chunks = 